module.exports = __webpack_public_path__ + "static/media/article-icon-head.f99ff5b9.svg";